module.exports = Em.ObjectController.extend({
    needs: ['bankSync', 'organization'],

    model: Em.computed.alias('controllers.bankSync.model'),

    bankLineMatches: function() {
        var account = this.get('model')
        return Billy.BankLineMatch.filter({
            query: {
                account: account,
                isApproved: true
            },
            sortProperty: 'entryDate',
            remoteQuery: {
                include: 'bankLineMatch.lines,bankLineMatch.subjectAssociations,bankLineSubjectAssociation.subject'
            }
        })
    }.property('model', 'matchesSortProperty')
})
